import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import Points from './components/points.vue'
import Task from './components/task.vue'
import Rule from './components/rule.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MarketingPoints',
  setup(__props) {

const current = ref<('points' | 'task' | 'rule')[]>(['points']);

return { __sfc: true,current, Points, Task, Rule }
}

})